import React, { useState } from "react"
import { injectIntl } from "react-intl"
import Select from "react-select"
import { Intl } from "../../state/helpers/IntlProps"
import { PAYMENT_3DS_STATUS } from "../../state/helpers/Payment"
import { getPayment3DSStatusOptions } from "./utils"

type OwnProps = {
    intl: Intl
    multi: boolean
    onChange: (selectedOpts: string[], selectedOptsLabels: string) => void
}

const Payment3DSStatusSelect = (props: OwnProps) => {
    const [selectedOption, setSelectedOption] = useState<PAYMENT_3DS_STATUS | PAYMENT_3DS_STATUS[]>([])

    const onChangeSelect = (selectedOpts) => {
        setSelectedOption(selectedOpts)

        if (props.multi) {
            props.onChange(selectedOpts.map(option => option.value), selectedOpts.map(option => option.label).join(","))
        } else {
            props.onChange(selectedOpts.value, selectedOpts.label)
        }

    }

    return <Select
        id="payment-3ds-status-select"
        name="payment-3ds-status-select"
        multi={props.multi}
        value={selectedOption}
        onChange={onChangeSelect}
        options={getPayment3DSStatusOptions(props.intl)}
    />
}

export default injectIntl(Payment3DSStatusSelect)


// WEBPACK FOOTER //
// ./src/payment/components/payment3DSStatusSelect.tsx